// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Report$ReactHooksTemplate = require("./report.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var Campaign$ReactHooksTemplate = require("../surveys/campaign.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var ReportCrud$ReactHooksTemplate = require("./ReportCrud.res.js");
var UserDetail$ReactHooksTemplate = require("../common/UserDetail.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var CustomReport$ReactHooksTemplate = require("./CustomReport.res.js");
var SurveyDetail$ReactHooksTemplate = require("../surveys/surveyDetail.res.js");
var AggregateField$ReactHooksTemplate = require("./AggregateField.res.js");
var ReportTemplate$ReactHooksTemplate = require("./ReportTemplate.res.js");
var ResponseReport$ReactHooksTemplate = require("./ResponseReport.res.js");
var AggregateReport$ReactHooksTemplate = require("./AggregateReport.res.js");
var DataRestriction$ReactHooksTemplate = require("../settings/dataRestriction.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var ReportListHeader$ReactHooksTemplate = require("./ReportListHeader.res.js");

function reducer(state, action) {
  if (typeof action !== "object") {
    return {
            reports: state.reports,
            selectedReport: state.selectedReport,
            reportChangeModalToggle: !state.reportChangeModalToggle,
            action: state.action,
            outsideClick: state.outsideClick
          };
  }
  switch (action.TAG) {
    case "LoadReports" :
        var reports = action._0;
        if (reports !== undefined) {
          return {
                  reports: reports,
                  selectedReport: state.selectedReport,
                  reportChangeModalToggle: state.reportChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        } else {
          return {
                  reports: undefined,
                  selectedReport: state.selectedReport,
                  reportChangeModalToggle: state.reportChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        }
    case "SetReport" :
        var report = action._0;
        if (report !== undefined) {
          return {
                  reports: state.reports,
                  selectedReport: report,
                  reportChangeModalToggle: state.reportChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        } else {
          return {
                  reports: state.reports,
                  selectedReport: undefined,
                  reportChangeModalToggle: state.reportChangeModalToggle,
                  action: state.action,
                  outsideClick: state.outsideClick
                };
        }
    case "SetAction" :
        return {
                reports: state.reports,
                selectedReport: state.selectedReport,
                reportChangeModalToggle: state.reportChangeModalToggle,
                action: action._0,
                outsideClick: state.outsideClick
              };
    case "SetReportChangeModal" :
        return {
                reports: state.reports,
                selectedReport: state.selectedReport,
                reportChangeModalToggle: action._0,
                action: state.action,
                outsideClick: state.outsideClick
              };
    case "SetOutsideClick" :
        return {
                reports: state.reports,
                selectedReport: state.selectedReport,
                reportChangeModalToggle: state.reportChangeModalToggle,
                action: state.action,
                outsideClick: action._0
              };
    
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1",
  currentPage: "1"
};

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var initialState = {
  reports: undefined,
  selectedReport: undefined,
  reportChangeModalToggle: false,
  action: "Create",
  outsideClick: true
};

function ReportList(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var fetchReports = function (param) {
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var perPage = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  var reports = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("reports", (function (param) {
                                            return Json_decode.list(Report$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  return Promise.resolve([
                              reports,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader("/api/v1/reports.json"));
  };
  var buildTargetDict = function (report) {
    var params = {};
    var template = Report$ReactHooksTemplate.reportTemplate(report);
    if (template !== undefined) {
      var template$1 = ReportTemplate$ReactHooksTemplate.template(template);
      switch (template$1.TAG) {
        case "AggregateReport" :
            var template$2 = template$1._0;
            var aggregateFieldParams = {};
            aggregateFieldParams["data_field_id"] = Belt_Option.getExn(DataField$ReactHooksTemplate.id(Belt_Option.getExn(AggregateField$ReactHooksTemplate.dataField(Belt_Option.getExn(AggregateReport$ReactHooksTemplate.aggregateFields(template$2))))));
            aggregateFieldParams["is_timestamp"] = AggregateField$ReactHooksTemplate.isTimestamp(Belt_Option.getExn(AggregateReport$ReactHooksTemplate.aggregateFields(template$2)));
            var value = AggregateField$ReactHooksTemplate.timeFrame(Belt_Option.getExn(AggregateReport$ReactHooksTemplate.aggregateFields(template$2)));
            var timeFrame = value !== undefined ? AggregateField$ReactHooksTemplate.timeFrameToString(value) : "";
            aggregateFieldParams["time_frame"] = timeFrame;
            var aggregateParams = {};
            aggregateParams["metric"] = AggregateReport$ReactHooksTemplate.metricToString(Belt_Option.getExn(AggregateReport$ReactHooksTemplate.metric(template$2)));
            aggregateParams["aggregate_fields_attributes"] = Json_encode.array((function (prim) {
                    return prim;
                  }), [aggregateFieldParams]);
            params[AggregateReport$ReactHooksTemplate.templateType] = aggregateParams;
            break;
        case "CustomReport" :
            var template$3 = template$1._0;
            var customParams = {};
            customParams["name"] = CustomReport$ReactHooksTemplate.name(template$3);
            var reportLogicId = CustomReport$ReactHooksTemplate.reportLogicId(template$3);
            customParams["organization_custom_report_id"] = Belt_Option.getExn(reportLogicId);
            params[CustomReport$ReactHooksTemplate.templateType] = customParams;
            break;
        case "ResponseReport" :
            var template$4 = template$1._0;
            var responseParams = {};
            responseParams["survey_id"] = SurveyDetail$ReactHooksTemplate.id(Belt_Option.getExn(ResponseReport$ReactHooksTemplate.survey(template$4)));
            var campaign_ids = Belt_List.toArray(Belt_List.map(ResponseReport$ReactHooksTemplate.campaigns(template$4), Campaign$ReactHooksTemplate.id));
            responseParams["campaign_ids"] = Json_encode.array((function (prim) {
                    return prim;
                  }), campaign_ids);
            params[ResponseReport$ReactHooksTemplate.templateType] = responseParams;
            break;
        
      }
    }
    params["id"] = Json_encode.nullable((function (prim) {
            return prim;
          }), Report$ReactHooksTemplate.id(report));
    params["data_filters_attributes"] = Json_encode.array(DataRestriction$ReactHooksTemplate.encode, Belt_List.toArray(Report$ReactHooksTemplate.allFilters(report)));
    params["name"] = Report$ReactHooksTemplate.name(report);
    params["description"] = Report$ReactHooksTemplate.description(report);
    params["time_frame"] = Report$ReactHooksTemplate.timeFrame(report);
    params["template_type"] = ReportTemplate$ReactHooksTemplate.templateType(ReportTemplate$ReactHooksTemplate.template(Belt_Option.getExn(Report$ReactHooksTemplate.reportTemplate(report))));
    var responseParams$1 = {};
    responseParams$1["report"] = params;
    return responseParams$1;
  };
  var match$2 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$2[0];
  var canCreateReport = Curry._1(hasPermission, "CreateReport");
  var canEditReport = Curry._1(hasPermission, "EditReport");
  var canDeleteReport = Curry._1(hasPermission, "DeleteReport");
  var canManageReport = canEditReport || canDeleteReport;
  var handlePageChange = function (pageNumber) {
    var pageNumber$1 = String(pageNumber);
    RescriptReactRouter.push("/users/all?page=" + pageNumber$1);
    Curry._1(setPageInfo, (function (pageInfo) {
            return {
                    total: pageInfo.total,
                    perPage: pageInfo.perPage,
                    currentPage: pageNumber$1
                  };
          }));
    window.scrollTo(0.0, 0.0);
  };
  var handleChange = function (report, action) {
    if (report === undefined) {
      return ;
    }
    switch (action) {
      case "Create" :
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", Json_decode.string, response);
                  var report = Json_decode.field("report", Report$ReactHooksTemplate.decode, response);
                  if (status !== "success") {
                    return Promise.resolve((console.log("error"), undefined));
                  }
                  var reports = state.reports;
                  if (reports !== undefined) {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadReports",
                                      _0: List.append({
                                            hd: report,
                                            tl: /* [] */0
                                          }, reports)
                                    }), Curry._1(dispatch, {
                                      TAG: "SetReportChangeModal",
                                      _0: false
                                    })));
                  } else {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadReports",
                                      _0: {
                                        hd: report,
                                        tl: /* [] */0
                                      }
                                    }), Curry._1(dispatch, {
                                      TAG: "SetReportChangeModal",
                                      _0: false
                                    })));
                  }
                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/reports", buildTargetDict(report)));
          return ;
      case "Edit" :
          var reportId = Report$ReactHooksTemplate.id(report);
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", Json_decode.string, response);
                  if (status !== "success") {
                    return Promise.resolve((console.log("error"), undefined));
                  }
                  var reportId = Report$ReactHooksTemplate.id(report);
                  var reports = state.reports;
                  if (reports !== undefined) {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadReports",
                                      _0: Belt_List.map(reports, (function (x) {
                                              if (Caml_obj.equal(Report$ReactHooksTemplate.id(x), reportId)) {
                                                return report;
                                              } else {
                                                return x;
                                              }
                                            }))
                                    }), Curry._1(dispatch, {
                                      TAG: "SetReportChangeModal",
                                      _0: false
                                    })));
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "SetReportChangeModal",
                                    _0: false
                                  }));
                  }
                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/reports/" + String(Belt_Option.getExn(reportId)) + "/update", buildTargetDict(report)));
          return ;
      case "Delete" :
          var reportId$1 = Report$ReactHooksTemplate.id(report);
          Js_promise.then_((function (response) {
                  var status = Json_decode.field("status", Json_decode.string, response);
                  if (status !== "success") {
                    return Promise.resolve((console.log("error"), undefined));
                  }
                  var reportId = Report$ReactHooksTemplate.id(report);
                  var reports = state.reports;
                  if (reports !== undefined) {
                    return Promise.resolve((Curry._1(dispatch, {
                                      TAG: "LoadReports",
                                      _0: Belt_List.keep(reports, (function (x) {
                                              return Caml_obj.notequal(Report$ReactHooksTemplate.id(x), reportId);
                                            }))
                                    }), Curry._1(dispatch, {
                                      TAG: "SetReportChangeModal",
                                      _0: false
                                    })));
                  } else {
                    return Promise.resolve(Curry._1(dispatch, {
                                    TAG: "SetReportChangeModal",
                                    _0: false
                                  }));
                  }
                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/reports/" + String(Belt_Option.getExn(reportId$1)) + "/delete", {}));
          return ;
      
    }
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (param) {
                  var paginationInfo = param[1];
                  var perPage = paginationInfo[1];
                  var total = paginationInfo[0];
                  Curry._1(setPageInfo, (function (state) {
                          return {
                                  total: total,
                                  perPage: perPage,
                                  currentPage: state.currentPage
                                };
                        }));
                  return Promise.resolve(Js_promise.then_((function (xs) {
                                    return Promise.resolve(Curry._1(dispatch, {
                                                    TAG: "LoadReports",
                                                    _0: xs
                                                  }));
                                  }), param[0]));
                }), fetchReports());
        }), [pageInfo.currentPage]);
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.perPage);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  var page$1 = Belt_Int.fromString(pageInfo.currentPage);
  var paginationCurrentPage = page$1 !== undefined ? page$1 : currentPage;
  var tmp;
  if (Curry._1(hasPermission, "ShowReport")) {
    var reports = state.reports;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("h2", {
                        children: "Reports",
                        className: "text-xl font-semibold"
                      }),
                  className: "flex items-center border-b border-gray-300 px-30-px py-16-px justify-between"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("button", {
                                children: "Report Automailer",
                                className: "inline-flex items-center justify-center h-9 px-3 sm:px-4 leading-none bg-ghostwhite border border-gray-400 text-darkcharcoal text-sm font-semibold rounded-lg hover:border-pigmentblue hover:text-pigmentblue focus:outline-none focus:ring-2 focus:ring-pigmentblue focus:ring-offset-2 transition-all duration-200 cursor-pointer whitespace-nowrap",
                                type: "button",
                                onClick: (function (param) {
                                    RescriptReactRouter.push("/reports/automailer");
                                  })
                              }),
                          canCreateReport ? JsxRuntime.jsxs("button", {
                                  children: [
                                    JsxRuntime.jsx("span", {
                                          children: "+",
                                          className: "text-base leading-none font-bold pointer-events-none"
                                        }),
                                    "New Report"
                                  ],
                                  className: "inline-flex items-center justify-center gap-1.5 sm:gap-2 h-9 px-3 sm:px-4 leading-none bg-pigmentblue text-white text-sm font-semibold rounded-lg hover:bg-cetaceanblue hover:shadow-md active:bg-cetaceanblue focus:outline-none focus:ring-2 focus:ring-pigmentblue focus:ring-offset-2 transition-all duration-200 cursor-pointer whitespace-nowrap",
                                  id: "add-report",
                                  type: "button",
                                  onClick: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: "SetAction",
                                            _0: "Create"
                                          });
                                      Curry._1(dispatch, {
                                            TAG: "SetReport",
                                            _0: undefined
                                          });
                                      Curry._1(dispatch, "ToggleReportChangeModal");
                                    })
                                }) : null
                        ],
                        className: "flex items-center gap-2"
                      }),
                  className: "flex justify-end px-30-px pt-20-px pb-4 items-center gap-2"
                }),
            JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                  currentPage: paginationCurrentPage,
                  totalPages: totalPagesCount,
                  totalRecords: totalCount,
                  perPage: perPageCount,
                  handlePageChange: handlePageChange,
                  itemLabel: "reports",
                  className: "mx-30-px mb-4"
                }),
            reports !== undefined ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("table", {
                          children: [
                            JsxRuntime.jsx(ReportListHeader$ReactHooksTemplate.make, {}),
                            JsxRuntime.jsx("tbody", {
                                  children: $$Array.of_list(List.map((function (report) {
                                              var reportId = Report$ReactHooksTemplate.id(report);
                                              var tmp;
                                              if (canManageReport) {
                                                var selectedReport = state.selectedReport;
                                                tmp = JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "h-18-px",
                                                              src: Image$ReactHooksTemplate.verticalDots,
                                                              onClick: (function (param) {
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetOutsideClick",
                                                                        _0: !state.outsideClick
                                                                      });
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetReport",
                                                                        _0: report
                                                                      });
                                                                })
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                canEditReport ? JsxRuntime.jsxs("a", {
                                                                        children: [
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "h-12-px",
                                                                                src: Image$ReactHooksTemplate.edit
                                                                              }),
                                                                          "Edit"
                                                                        ],
                                                                        className: "flex text-xs gap-2",
                                                                        onClick: (function (param) {
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetOutsideClick",
                                                                                  _0: true
                                                                                });
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetAction",
                                                                                  _0: "Edit"
                                                                                });
                                                                            Curry._1(dispatch, "ToggleReportChangeModal");
                                                                          })
                                                                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                                canDeleteReport ? JsxRuntime.jsxs("a", {
                                                                        children: [
                                                                          JsxRuntime.jsx("img", {
                                                                                className: "h-12-px",
                                                                                src: Image$ReactHooksTemplate.trash
                                                                              }),
                                                                          "Delete"
                                                                        ],
                                                                        className: "flex text-xs gap-2",
                                                                        onClick: (function (param) {
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetOutsideClick",
                                                                                  _0: true
                                                                                });
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetAction",
                                                                                  _0: "Delete"
                                                                                });
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetReport",
                                                                                  _0: report
                                                                                });
                                                                            Curry._1(dispatch, "ToggleReportChangeModal");
                                                                          })
                                                                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                              ],
                                                              className: "flex flex-col items-search p-2 absolute rounded border border-gray-400 bg-white\n                                        text-darkcharcoal text-xs question-dropdown z-50 opacity-100 gap-2 w-20 " + (
                                                                selectedReport !== undefined && state.outsideClick === false && Caml_obj.equal(selectedReport, report) ? "block" : "hidden"
                                                              )
                                                            })
                                                      ],
                                                      className: "flex justify-end items-center relative"
                                                    });
                                              } else {
                                                tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                              }
                                              return JsxRuntime.jsxs("tr", {
                                                          children: [
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsxs("a", {
                                                                        children: [
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("div", {
                                                                                      children: Report$ReactHooksTemplate.name(report)[0],
                                                                                      className: "m-auto"
                                                                                    }),
                                                                                className: "w-8 h-8 flex items-center text-white uppercase mr-3 rounded-lg " + Utils$ReactHooksTemplate.randomBgColor()
                                                                              }),
                                                                          Report$ReactHooksTemplate.name(report)
                                                                        ],
                                                                        className: "flex items-center",
                                                                        href: "/reports/" + String(Belt_Option.getExn(reportId))
                                                                      }),
                                                                  className: "px-4 py-3 capitalize"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("a", {
                                                                        children: Report$ReactHooksTemplate.description(report),
                                                                        href: "/reports/" + String(Belt_Option.getExn(reportId))
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("a", {
                                                                        children: ReportTemplate$ReactHooksTemplate.templateName(Belt_Option.getExn(Report$ReactHooksTemplate.reportTemplate(report))),
                                                                        href: "/reports/" + String(Belt_Option.getExn(reportId))
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("a", {
                                                                        children: Utils$ReactHooksTemplate.humanize(Report$ReactHooksTemplate.timeFrame(report)),
                                                                        href: "/reports/" + String(Belt_Option.getExn(reportId))
                                                                      }),
                                                                  className: "px-4 py-3 capitalize"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("a", {
                                                                        children: UserDetail$ReactHooksTemplate.email(Belt_Option.getExn(Report$ReactHooksTemplate.creator(report))),
                                                                        href: "/reports/" + String(Belt_Option.getExn(reportId))
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: JsxRuntime.jsx("a", {
                                                                        children: UserDetail$ReactHooksTemplate.email(Belt_Option.getExn(Report$ReactHooksTemplate.modifier(report))),
                                                                        href: "/reports/" + String(Belt_Option.getExn(reportId))
                                                                      }),
                                                                  className: "px-4 py-3"
                                                                }),
                                                            JsxRuntime.jsx("td", {
                                                                  children: tmp,
                                                                  className: "px-4 py-3"
                                                                })
                                                          ],
                                                          className: "border-b border-bottom-gray-600"
                                                        });
                                            }), reports))
                                })
                          ],
                          className: "text-left table-auto w-full border-separate text-sm font-medium"
                        }),
                    className: "flex px-30-px pb-30-px"
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                    children: Caml_option.some(JsxRuntime.jsx("p", {
                              children: "Fetching users..."
                            }))
                  }),
            state.reportChangeModalToggle ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(ReportCrud$ReactHooksTemplate.make, {
                          handleChange: handleChange,
                          report: state.selectedReport,
                          action: state.action,
                          toggleModal: (function (param) {
                              Curry._1(dispatch, "ToggleReportChangeModal");
                            }),
                          subscriptionPlans: props.subscriptionPlans
                        }),
                    className: "w-screen z-10 disabled-wrapper fixed inset-0 flex justify-center items-center",
                    style: {
                      height: "calc(100vh + 5rem)"
                    }
                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
          ]
        });
  } else {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                text: "401: Unauthorized!!",
                loading: false
              }),
          className: "h-screen w-full animated fadeIn"
        });
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(tmp)
            });
}

var make = ReportList;

exports.reducer = reducer;
exports.emptyPageInfo = emptyPageInfo;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
